// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"5266dc9b","187":"235887cf","191":"89bbbaef","252":"26ab533d","318":"5f221498","439":"8e77a661","480":"461930d1","563":"c8e9702d","632":"acd2dc2a","763":"2e8af6cb","845":"8dd33c75","883":"a528ea40","974":"20d7a242"}[chunkId] + ".chunk.js";
};